import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import BonusesLoadingIndicatorImpl from './bonuses-loading-indicator.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Component responsible for presenting the loading view of bonuses.
 *
 * @class BonusesLoadingIndicator
 * @memberof Mojito.Modules.Bonuses
 */

/**
 * BonusesLoadingIndicator prop types.
 *
 * @property {string} [labelClassName] - Class that will be applied to loading label.
 *
 * @memberof Mojito.Modules.Bonuses.BonusesLoadingIndicator
 */
const propTypes = {
    labelClassName: PropTypes.string,
};

export default UIView('BonusesLoadingIndicator', BonusesLoadingIndicatorImpl, propTypes);
